<template>
    <v-row v-resize="onResize" no-gutters class="fill-height">
        <v-col
            cols="12"
            md="3"
            sm="12"
            lg="3"
            ref="menu"
            class="border-right d-flex flex-column flex-nowrap"
            :style="{ height: `${height}px` }"
        >
            <!-- Back button -->
            <div class="pa-3 border-bottom">
                <v-btn
                    block
                    color="primary"
                    rounded
                    :to="{ name: 'wo' }"
                    class="text-transform-none"
                >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back to Operator
                </v-btn>
            </div>

            <div
                v-if="loading"
                class="d-flex align-center justify-center flex-grow-1"
            >
                <v-progress-circular color="primary" indeterminate />
            </div>
            <!-- Settings list -->
            <v-list v-else class="overflow-y-auto pa-0">
                <template v-if="operatorSettings.length > 0">
                    <v-list-item-group>
                        <v-list-item
                            v-for="(setting, i) in operatorSettings"
                            :key="i"
                            color="primary"
                            three-line
                            @click="hide"
                            link
                            :to="{
                                name:
                                    setting.nameRoute ||
                                    setting.name.toLowerCase(),
                                params: { setting: setting },
                            }"
                            :class="{
                                'border-bottom':
                                    i < operatorSettings.length - 1,
                            }"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="mt-3">
                                    {{
                                        setting.name === 'Quality'
                                            ? 'Quality (NC Codes)'
                                            : setting.name === 'FinishAndUCCode'
                                            ? 'Finish & UC Code'
                                            : setting.name
                                    }}
                                </v-list-item-title>
                                <v-list-item class="pa-0">
                                    <v-list-item-icon class="mt-2 mb-0">
                                        <v-icon>mdi-cog-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-subtitle class="mt-0">
                                        Settings
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </template>
            </v-list>
        </v-col>
        <v-col
            sm="0"
            cols="12"
            md="9"
            lg="9"
            class="overflow-y-auto"
            :style="{ height: `${height}px` }"
        >
            <router-view @show="show" />
        </v-col>
    </v-row>
</template>

<script>
import API from '@/services/api'
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'OperatorSettings',
    data() {
        return {
            loading: false,
            height: 0,
            company: JSON.parse(localStorage.getItem('company')),
            folder: 'company_logo',
            operatorSettings: [],
        }
    },

    computed: {
        ...mapState(['userRef']),
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onResize() {
            this.height =
                window.innerHeight - this.$vuetify.application.top - 40
        },
        hide() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$refs.menu.classList.remove('d-flex')
                this.$refs.menu.classList.add('d-none')
            }
        },
        show() {
            this.$refs.menu.classList.remove('d-none')
            this.$refs.menu.classList.add('d-flex')
        },
    },
    async created() {
        try {
            this.loading = true

            // Get settings
            const {
                data: { settings },
            } = await API.getSettings()

            // Add Finish and UC Code
            const finish = settings.find(x => x.name == 'FinishAndUCCode')
            if (finish) {
                const finishTab = {
                    ...finish,
                    nameRoute: 'operator-finish-and-uc-code',
                }
                this.operatorSettings.push(finishTab)
            }

            // Add Quality tab
            const quality = settings.find(x => x.name == 'Quality')
            if (quality) {
                const qualityTab = {
                    name: 'Quality',
                    id: quality.id,
                    nameRoute: 'operator-qualitySettings',
                    quality: quality || {},
                }
                this.operatorSettings.push(qualityTab)
            }

            // Navigate to first setting with params if no child route is active
            if (
                this.operatorSettings.length > 0 &&
                this.$route.name === 'operator-settings'
            ) {
                const firstSetting = this.operatorSettings[0]
                this.$router.replace({
                    name: firstSetting.nameRoute,
                    params: { setting: firstSetting },
                })
            }
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
}
</script>

<style scoped>
.border-right {
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: #f0f0f0;
}
.border-bottom {
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #f0f0f0;
}
</style>
